import PropTypes from 'prop-types';
import React from 'react';
import useBrandName from 'src/hooks/use-brand-name';

const Criterion = ({criterionType, displayString}) => {
  const brandName = useBrandName();

  if (!brandName) {
    return null;
  }

  return (
    <div className="flex-row">
      <span>{criterionType.replace(/Raise Me/g, brandName)}</span>
      <strong>{displayString}</strong>
    </div>
  );
};

Criterion.propTypes = {
  criterionType: PropTypes.string.isRequired,
  displayString: PropTypes.string.isRequired,
};

export default Criterion;
